import { Formik, Form } from 'formik';
import ScrollToError from 'components/common/ScrollToError';
import Button from 'components/common/Button';
import { useIntl } from 'react-intl';
import { ArrowBack, ArrowForward } from 'assets/icons';
import { Col, Row } from 'react-flexbox-grid';
import Img from 'assets/images/renovation-house/step-3.svg?react';
import SaveIcon from 'assets/icons/save.svg?react';
import ScrollToTop from 'components/common/ScrollToTop';
import { RENOVATION_HOUSE } from 'constants/constants';
import Features from '../../Features';
import s from '../../calculators.module.scss';
import validationSchema from '../yupSchemas/renovationHouseSeventhStepSchema';
import type { IRenovationHouseStepProps } from '../types';

const RenovationHouseSixthStep = ({
  onSubmit,
  lastStep,
  previousStep,
  nextStep,
  isEditMode,
  formValuesRef,
  initialValues,
  onBack,
}: IRenovationHouseStepProps) => {
  const { formatMessage: t } = useIntl();

  return (
    <Row between="lg" center="md">
      <ScrollToTop />
      <Col md={8} lg={6}>
        <Formik
          initialValues={isEditMode ? initialValues : formValuesRef?.current}
          onSubmit={async (values, formikActions) => {
            await onSubmit({ values, formikActions, isEditMode: true, lastStep, nextStep });
          }}
          validationSchema={validationSchema}
        >
          {({ values, isSubmitting }) => (
            <Form>
              <ScrollToError />
              <Features values={values} group="other" projectType={RENOVATION_HOUSE} />

              <div className={s.buttonsWrapper}>
                {!isEditMode ? (
                  <Button
                    disabled={isSubmitting}
                    onClick={() => onBack(values, previousStep)}
                    startIcon={<ArrowBack />}
                  >
                    {t({ id: 'app.back' })}
                  </Button>
                ) : null}
                <Button
                  loading={isSubmitting}
                  disabled={isSubmitting}
                  type="submit"
                  endIcon={isEditMode ? <SaveIcon /> : <ArrowForward />}
                  className="ml-auto"
                >
                  {t({ id: `app.${isEditMode ? 'save' : 'submit_form_next'}` })}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Col>
      <Col md={8} lg={6} first="xs" last="lg">
        <div className={s.imgBox}>
          <Img title={t({ id: 'alt_text.project_details_page.renovation_house.seventh_step' })} />
        </div>
      </Col>
    </Row>
  );
};

export default RenovationHouseSixthStep;
